import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';

interface ProviderMicrodataProps {
  provider: ProviderMatchProviderV9;
  canonicalUrl?: string;
}

const ProviderMicrodata = ({
  provider
}: ProviderMicrodataProps): React.ReactElement => {
  return (
    <>
      <meta itemProp="publicAccess" content="true" />
      <meta
        itemProp="isAcceptingNewPatients"
        content={provider.accepting_new_patients ? 'true' : 'false'}
      />
      {provider.insurance_accepted.map(
        (insuranceName: string, index: number) => (
          <meta
            itemProp="healthPlanNetworkId"
            content={insuranceName}
            key={insuranceName + index}
          />
        )
      )}
      {(provider.languages as string[]).map(
        (language: string, index: number) => (
          <meta
            itemProp="knowsLanguage"
            content={language}
            key={language + index}
          />
        )
      )}
      {provider.npi && (
        <React.Fragment>
          <meta itemProp="usNPI" content={provider.npi} />
          <meta
            itemProp="sameAs"
            content={`https://npiregistry.cms.hhs.gov/provider-view/${provider.npi}`}
          />
        </React.Fragment>
      )}
    </>
  );
};

export default ProviderMicrodata;
